import type { Image } from "sanity";
import { createImageUrlBuilder, type SanityImageRect } from "@sanity/image-url";
import { getSanityDataset } from "../datasets";

export type { SanityImageRect };

const imageBuilder = createImageUrlBuilder({
  projectId: "l0whhinj", // TODO: Move this to a `sanity.constants.ts` file?
  dataset: getSanityDataset(),
});

// Need to know which dataset the image comes from... (i. e. Sanity Main or "local" Sanity)
export const urlForImage = (
  image: Image,
  width: number,
  height: number,
  crop?: SanityImageRect,
) => {
  return crop
    ? imageBuilder
        ?.image(image)
        .rect(crop.left, crop.top, crop.width, crop.height)
        .auto("format")
        .fit("max")
    : imageBuilder
        ?.image(image)
        .width(width)
        .height(height)
        .auto("format")
        .fit("max");
};
